// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"279":"aad146335d9cd4148a6c","419":"f68bac87c6816f2f0354"}[chunkId] + ".js";
};